import React from 'react';
import { FormattedMessage } from 'react-intl';
import Proptypes from 'prop-types';
import {
  SaleEventHeaderVariant,
  TradeState
} from '../../../../_shared/types/trade';
import BadgeWithTooltip from '../../../../_shared/components/BadgeWithTooltip';

import {
  StyledBox,
  StyledColumnBox,
  StyledEventName,
  StyledContentHeader,
  StyledContentBody,
  StyledHeader,
  StyledRowBox,
  StyledVehicleCount,
  StyledIcon
} from './Styles';

const propTypes = {
  testId: Proptypes.string.isRequired,
  className: Proptypes.string.isRequired,
  variant: Proptypes.oneOf([
    SaleEventHeaderVariant.COMPLETE,
    SaleEventHeaderVariant.CONTINUED
  ]).isRequired,
  tradeState: Proptypes.oneOf([TradeState.upcoming, TradeState.active])
    .isRequired,
  tradeSummary: Proptypes.objectOf(Proptypes.any).isRequired,
  shouldHideHostedBy: Proptypes.bool.isRequired,
  isChangeHostedBy: Proptypes.bool.isRequired,
  launchIdSale: Proptypes.string.isRequired,
  launchValues: Proptypes.objectOf(Proptypes.any).isRequired
};

const ListSaleEventHeader = ({
  testId,
  className,
  variant,
  tradeState,
  tradeSummary: { saleEventSummary, dealer, network },
  shouldHideHostedBy,
  isChangeHostedBy,
  launchIdSale,
  launchValues
}) => (
  <StyledBox testId={testId} className={className} id={className}>
    <StyledRowBox>
      <StyledHeader>
        {variant === SaleEventHeaderVariant.CONTINUED ? (
          <FormattedMessage id="list.saleEvent.dealer.event.continued" />
        ) : (
          <FormattedMessage id="list.saleEvent.dealer.event" />
        )}
      </StyledHeader>
      {saleEventSummary?.numberOfTrades && (
        <StyledVehicleCount>
          {saleEventSummary?.numberOfTrades}{' '}
          <FormattedMessage id="list.saleEvent.vehicles" />
        </StyledVehicleCount>
      )}
    </StyledRowBox>
    <StyledEventName data-testid="list-saleEvent-name" variant={variant}>
      {saleEventSummary?.name}
    </StyledEventName>
    <StyledRowBox variant={variant} testId="list-saleEvent-content">
      {network?.isDealerGroupNetwork && network?.displayName && (
        <StyledColumnBox>
          <StyledContentHeader>
            <FormattedMessage id="list.saleEvent.network" />
          </StyledContentHeader>
          <StyledContentBody>
            <StyledIcon />
            {network?.displayName}
          </StyledContentBody>
        </StyledColumnBox>
      )}
      {dealer?.displayName && !shouldHideHostedBy && (
        <StyledColumnBox testId={`${testId}-hostedBy`}>
          <StyledContentHeader>
            <FormattedMessage id="list.saleEvent.hosted.by" />
          </StyledContentHeader>
          <StyledContentBody>
            {!isChangeHostedBy && dealer?.dealerBadges?.length > 0 && (
              <BadgeWithTooltip badges={dealer?.dealerBadges} />
            )}
            {isChangeHostedBy
              ? saleEventSummary?.dgnNetwork
              : dealer?.displayName}
          </StyledContentBody>
        </StyledColumnBox>
      )}
      {tradeState &&
        tradeState === TradeState.upcoming &&
        launchIdSale &&
        launchValues && (
          <StyledColumnBox>
            <StyledContentHeader>
              <FormattedMessage id="list.saleEvent.active" />
            </StyledContentHeader>
            <StyledContentBody>
              <FormattedMessage id={launchIdSale} values={launchValues} />
            </StyledContentBody>
          </StyledColumnBox>
        )}
    </StyledRowBox>
  </StyledBox>
);

ListSaleEventHeader.propTypes = propTypes;

export default ListSaleEventHeader;
